import { render, staticRenderFns } from "./MyCertificatesParticipant.vue?vue&type=template&id=37e5ead6"
import script from "./MyCertificatesParticipant.vue?vue&type=script&lang=js"
export * from "./MyCertificatesParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports